function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("style", {
  type: "text/css"
}, "\n\t.st0{fill:#FFFFFF;}\n");

var _ref3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M72.6,45.5c5.9,3.5,9,11.8,10.6,19.4c4.8-3.2,11-6.3,15.9-5.6c12.1,1.9,13.1,12.7,13.1,17.9 c0,0.6,0,1.1-0.1,1.7c3.3-1.1,6.8-1.5,10.3-1.1c15.1,2.4,23.9,15.2,25.4,28.2l17.8-14.4L91.5,0L0,74.1l24.6,30.3 C34.5,68.4,52.4,33.4,72.6,45.5z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M83.7,78.8c-5.8,5.7-9.5,13.3-10.5,21.3l1.5-1.4C80.8,92.7,83.5,87.1,83.7,78.8z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M123.6,81c-3.4-0.9-7.6-0.6-11.8,0.6c-2.3,9.9-11.7,18.4-18.5,18.2h-0.5l0.3-7c4-6.2,11-11.2,18-13.6 c0.1-0.7,0.2-1.3,0.2-2c0-4.4-5.5-7-10.1-7c-5.5,0.1-11.4,3-16.3,7.5l0,0c0,9.4-2.9,15.8-9.5,22.4h-15c0.8-10.1,10-25.1,18-31.7 c0.9-0.8,2.1-1.6,3.3-2.5c-1.3-2.7-3.3-4.7-6.6-4.7c-19.2,0-22.9,45.4-25.8,73.6l24.9,30.8l56.2-45.5 C140.7,105,135.4,84.2,123.6,81z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M109.8,82.2c-6.2,2.1-11.7,5.9-15.8,11C94.1,93.2,105.8,89.7,109.8,82.2z"
}));

function SvgLogoMeloBraga(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 165.7 165.6",
    style: {
      enableBackground: "new 0 0 165.7 165.6"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoMeloBraga);
export default __webpack_public_path__ + "static/media/logo_melo_braga.e8437d5c.svg";
export { ForwardRef as ReactComponent };